<div class="instituto-page">
    <h1 class="title">Instituto previdenciário</h1>

    <!-- Mesmo formato dos indicadores do Requerimento Online: total à esquerda e, ao lado, cada tipo
         de instituto com quantidade e percentual sobre uma barra única dividida na mesma proporção. -->
    <section class="indicadores" aria-label="Indicadores do Instituto Previdenciário" data-testid="instituto-indicadores">
      <div class="indicadores__total">
        <p class="indicadores__rotulo">Adesões ao Instituto Online</p>
        <p class="indicadores__valor" data-testid="indicador-valor">{{ indicadores().total }}</p>
      </div>

      <div class="indicadores__tipos">
        <ul class="indicadores__legenda">
          @for (tipo of indicadores().tipos; track tipo.label) {
            <li class="indicadores__tipo">
              <p class="indicadores__rotulo">
                <span class="indicadores__cor" [style.background-color]="tipo.color" aria-hidden="true"></span>
                {{ tipo.label }}
              </p>
              <p class="indicadores__quantidade">
                <span class="indicadores__valor" data-testid="indicador-valor">{{ tipo.valorTexto }}</span>
                <span class="indicadores__percentual" data-testid="indicador-percentual">{{ tipo.percentual }}%</span>
              </p>
            </li>
          }
        </ul>

        <!-- Só visual: os números já estão na legenda acima. -->
        <div class="indicadores__barra" aria-hidden="true" data-testid="indicadores-barra">
          @for (tipo of indicadores().tipos; track tipo.label) {
            @if (tipo.value) {
              <span class="indicadores__fatia" [style.flex-grow]="tipo.value" [style.background-color]="tipo.color"></span>
            }
          }
        </div>
      </div>
    </section>

    <section class="status-pie-chart-section" aria-labelledby="status-pie-chart-title">
      <div>
        <h2 id="status-pie-chart-title" class="page-section-title">Adesões por instituto</h2>
        <app-status-pie-chart [segments]="adesoesPorInstituto()" />
      </div>
      <div>
        <h2 id="status-pie-chart-title" class="page-section-title">Adesões por status</h2>
        <app-status-pie-chart [segments]="adesoesPorStatus()" />
      </div>
    </section>

    <app-filter-bar [fields]="filterFields()" (filtersChange)="onFiltersChange($event)" />
    
    <!-- Lista sem painel em volta: a própria moldura branca da tabela é o card (mesmo layout de Planos). -->
    <section class="instituto__lista" aria-labelledby="solicitacoes-section-title" data-testid="instituto-lista">
      <h2 id="solicitacoes-section-title" class="page-section-title">Adesões ao Instituto Previdenciário</h2>

    @if (solicitacoes().length === 0) {
      <app-empty-state message="Nenhuma solicitação encontrada" />
    } @else {
      <div class="instituto__tabela-scroll">
        <table class="instituto__tabela" aria-label="Solicitações do Instituto Previdenciário" data-testid="instituto-tabela">
          <thead>
            <tr>
              <th scope="col" class="instituto__coluna-nome" [attr.aria-sort]="ariaSort('nome')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'nome', titulo: 'Participante' }" />
              </th>
              <th scope="col" class="instituto__coluna-matricula" [attr.aria-sort]="ariaSort('matricula')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'matricula', titulo: 'Matrícula' }" />
              </th>
              <th scope="col" class="instituto__coluna-plano">Plano</th>
              <th scope="col" class="instituto__coluna-instituto" [attr.aria-sort]="ariaSort('tipoInstituto')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'tipoInstituto', titulo: 'Instituto' }" />
              </th>
              <th scope="col" class="instituto__coluna-data" [attr.aria-sort]="ariaSort('dataSolicitacao')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'dataSolicitacao', titulo: 'Data Solicitação' }" />
              </th>
              <th scope="col" class="instituto__coluna-status" [attr.aria-sort]="ariaSort('status')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'status', titulo: 'Status' }" />
              </th>
              <th scope="col" class="instituto__coluna-acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            @for (solicitacao of solicitacoesPaginadas(); track solicitacao.idSolicitacao) {
              <tr data-testid="instituto-linha">
                <td class="instituto__coluna-nome">
                  <a
                    class="instituto__nome"
                    [routerLink]="['/instituto/detalhe', solicitacao.idSolicitacao]"
                    data-testid="campanha-link"
                  >
                    {{ solicitacao.nomeParticipante }}
                  </a>
                </td>
                <td class="instituto__coluna-matricula instituto__secundario" data-testid="solicitacao-matricula">{{ solicitacao.matricula }}</td>
                <td class="instituto__coluna-plano" data-testid="solicitacao-plano">{{ planoLabel(solicitacao.plano) }}</td>
                <td class="instituto__coluna-instituto" data-testid="solicitacao-instituto">{{ solicitacao.tipoInstituto }}</td>
                <td class="instituto__coluna-data instituto__secundario" data-testid="solicitacao-data-solicitacao">
                  {{ solicitacao.dataSolicitacao ? formatDate(solicitacao.dataSolicitacao) : '-' }}
                </td>
                <td class="instituto__coluna-status">
                  <app-instituto-status-tag [status]="solicitacao.statusUnificado" />
                </td>
                <td class="instituto__coluna-acoes">
                  <app-menu-acoes
                    [rotulo]="'Ações da solicitação de ' + solicitacao.nomeParticipante"
                    [opcoes]="opcoesMenu"
                    (escolher)="onAcao(solicitacao, $event)"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Título da coluna + seta; o estado da ordenação para leitores de tela fica no aria-sort do th. -->
      <ng-template #ordenar let-coluna="coluna" let-titulo="titulo">
        <button
          type="button"
          class="ordenar"
          [class.ordenar--ativo]="ariaSort(coluna) !== 'none'"
          [attr.data-testid]="'ordenar-' + coluna"
          (click)="ordenarPor(coluna)"
        >
          {{ titulo }}
          <vivest-icon class="ordenar__icone" [name]="iconeOrdenacao(coluna)" source="feather" aria-hidden="true"></vivest-icon>
        </button>
      </ng-template>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize()"
        [totalItems]="solicitacoes().length"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      />
    }
    </section>
  </div>